<template>
    <div id="compPreviewRight" :style="mobile_style">

        <div v-if="!gamemaster" id="compPreviewTop">
            <div v-show="instruction.text" class="gameInstruction"
                :class="{ gameInstructionExpanded: instructionExpanded }" @click="toggleInstructionExpanded">
                <i id="gameInstruction" class="fas fa-exclamation-triangle" />
                <div class="gameInstructionContainer">
                    <div ref="gameInstructionTextShort" class="gameInstructionTextShort"
                        :class="{ gameInstructionTextShortHide: instructionExpanded }">
                        {{ instruction.text }}
                    </div>
                    <div class="countdown">
                        <VueCountdown v-if="instruction_time ? instruction_time > 0 : false" :time="instruction_time"
                            :autoStart="true" :transform="transform" ref="countdown">
                            <template v-slot="props">
                                <span style="font-size: 1.1em;">{{ props.minutes }}:{{ props.seconds }}</span>
                            </template>
                        </VueCountdown>
                    </div>
                </div>
                <transition-expand>
                    <div v-if="instructionExpanded" class="gameInstructionText"
                        :class="{ gameInstructionExpanded: instructionExpanded }">
                        {{ instruction.text }}
                    </div>
                </transition-expand>
            </div>
        </div>

        <div id="compPreviewContent" :style="!gamemaster ? 'border-radius:0' : ''">

            <div class="messageContainer" v-if="content_id === 0">
                <div class="tlMessage">
                    <h1>{{ $t("common.contentArea") }}</h1>
                    <h2>{{ $t("common.contentGuide") }}</h2>
                </div>
            </div>

            <ArticlePreview v-else-if="content_type === 'article'" :title="previewData.title"
                :media_skin="previewData.media_skin" :dashboard="dashboard" :struct="previewData.struct"
                :custom_media_skin="previewData.custom_media_skin_id" />

            <AudioPreview v-else-if="content_type === 'audio'" id="audioPreviewItem" :file_url="previewData.file.url"
                :media_skin="previewData.media_skin" :title="previewData.label" :autoplay="auto_play" :preview="true" />

            <VideoPreview v-else-if="content_type === 'reactive_video'" :sources="previewData.sources" :preview="true"
                :autoplay="!gamemaster" />

            <img v-else-if="content_type === 'image'" :src="previewUrl" style="max-width: 95%; margin: auto;" />

            <iframe v-else-if="content_type === 'video' && !previewData.video_type_file"
                style="height: 25em; width: 95%; margin: auto" :src="previewUrl + (dashboard ? '' : '?autoplay=1')"
                frameborder="0" />

            <video v-else-if="content_type === 'video' && previewData.video_type_file" controls="true" :src="previewUrl"
                style="margin: auto; width: 95%" :autoplay="dashboard ? false : true" />

            <div v-show="!gamemaster" id="compPreviewBottom">
                <div class="newsBanner" id="nb1" v-show="newsbanner_text">
                    <Marquee :text="newsbanner_text" />
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown';
import axios from 'axios';
import dayjs from 'dayjs';
import { mapGetters, mapMutations } from 'vuex';
import { transform } from '../global/countdown_transform';
import ArticlePreview from './ArticlePreview';
import AudioPreview from './AudioPreview';
import Marquee from './Marquee';
import TransitionExpand from './TransitionExpand.vue';
import VideoPreview from './VideoPreview';

import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
export default {
    name: 'Preview',
    props: {
        gamemaster: Boolean,
        newsbanner_text: String,
        instruction_id: Number,
        pgroup_id: Number,
        dashboard: Boolean,
        mobile_style: String
    },
    components: {
        ArticlePreview,
        AudioPreview,
        VideoPreview,
        Marquee,
        VueCountdown,
        TransitionExpand
    },
    data() {
        return {
            previewData: {},
            previewUrl: "",
            content_id: 0,
            content_type: "",
            auto_play: false,
            instruction: {
                duration: 0,
                text: "",
                publish_time: null
            },
            instructionExpanded: false,
            instructionIsExpandable: false
        }
    },
    computed: {
        ...mapGetters([
            'getFileUrl'
        ]),
        instruction_time() {
            return dayjs.unix(this.instruction.publish_time).add(this.instruction.duration, 's').diff(dayjs(), 'ms')
        }
    },
    watch: {
        instruction_id(content_id) {
            if (content_id) this.getInstructionMeta(content_id)
            else
                this.instruction = {
                    duration: 0,
                    text: "",
                    publish_time: null
                }
        }
    },
    mounted() {
        this.$emit('loaded')
        if (this.instruction_id) this.getInstructionMeta(this.instruction_id)
        if (this.$refs.gameInstructionTextShort && !this.gamemaster) this.isInstructionExpandable()
    },
    methods: {
        ...mapMutations([
            'setParticipantGroupPreview',
            'setCurrPreview'
        ]),
        isInstructionExpandable() {
            setInterval(() => {
                /* check if instruction is overflowing, then toggle expandable property */
                const gameInstruction = this.$refs.gameInstructionTextShort

                if (gameInstruction && gameInstruction.clientWidth != 0) {
                    if (gameInstruction.scrollWidth > gameInstruction.clientWidth) {
                        this.instructionIsExpandable = true;
                    } else {
                        this.instructionIsExpandable = false;
                    }
                }
            }, 100)
        },
        toggleInstructionExpanded() {
            if (this.instructionIsExpandable) {
                this.instructionExpanded = !this.instructionExpanded
            }
        },
        getInstructionMeta(content_id) {
            axios.get('/api/content/' + content_id).then((response) => {
                this.instruction.duration = response.data.duration
                this.instruction.text = response.data.text.text
                this.instruction.publish_time = response.data.publish_time_ts
            })
        },
        showPreview(content_id) {
            if (this.content_id != content_id) this.setPreview(content_id)
            else this.clearPreview()
        },
        setPreview(content_id) {
            this.content_id = content_id
            if (this.pgroup_id) this.setParticipantGroupPreview({ pgroup_id: this.pgroup_id, content_id: content_id })
            else this.setCurrPreview(content_id)
            this.fetchContent()
        },
        clearPreview() {
            this.previewUrl = ""
            this.previewData = {}
            this.content_id = 0
            this.content_type = ""
            if (this.pgroup_id) this.setParticipantGroupPreview({ pgroup_id: this.pgroup_id, content_id: null })
            else this.setCurrPreview(null)
        },
        fetchContent() {
            this.content_type = ''
            axios.get("/api/content/" + this.content_id).then(response => {
                this.content_type = response.data.content_type
                if (this.content_type === 'article' || this.content_type === 'audio')
                    this.previewData = response.data
                else if (this.content_type === 'video') {
                    if (response.data.url) {
                        this.previewUrl = response.data.url
                        this.previewData.video_type_file = false
                    }
                    else {
                        this.previewUrl = this.getFileUrl(response.data.file_id)
                        this.previewData.video_type_file = true
                    }
                }
                else if (this.content_type == 'reactive_video')
                    this.previewData = {
                        label: response.data.label,
                        sources: response.data.ranges.map(v => ({
                            ...v,
                            src: this.getFileUrl(v.file_id)
                        }))
                    }
                else
                    this.previewUrl = response.data.file.url
            })
        },
        transform(props) {
            return transform(props)
        },
    }
}
</script>

<style>
#compPreviewContent {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 0;
    max-width: 100%;
    overflow-x: hidden;
    background-color: #FFF;
    border-radius: 1em;
}

.previewTabs {
    background-color: #3C404C;
    height: 100%;
    color: #FFF;
}

.previewTab {
    display: inline-flex;
    width: fit-content;
    padding: 0.5em;
    float: right;
    cursor: pointer;
}

.activeTab {
    color: #E86D00;
}

.expand-enter-active,
.expand-leave-active {
    transition-property: opacity, height;
}

.expand-enter,
.expand-leave-to {
    opacity: 0;
}

.countdown {
    margin-left: auto;
    font-weight: bold;
    position: absolute;
    right: 0;
    margin-right: 0.5em;
}
</style>
